
import { NavigationConfig } from '@library/Services/Navigation';

export const routes = [
    {
        path: '/',
        name: 'Home',
        meta: {
            allowAnonymous: true,
            title: 'Carbucks'
        },
        component: () => import( './modules/App/Home/HomePage.vue' ),
    },
    // {
    //     path: '/how-it-works',
    //     name: 'How It Works',
    //     meta: {
    //         allowAnonymous: true,
    //         title: 'How It Works'
    //     },
    //     component: () => import( './modules/App/HowItWorks/HowItWorks.vue' )
    // },
    {
        path: '/carbucks-rewards',
        name: 'Carbucks Rewards',
        meta: {
            allowAnonymous: true,
            title: 'Carbucks Rewards'
        },
        component: () => import( './modules/App/CarbucksRewards/CarbucksRewards.vue' )
    },
    {
        path: '/carbucks-protect',
        name: 'Carbucks Protect',
        meta: {
            allowAnonymous: true,
            title: 'Carbucks Protect'
        },
        component: () => import( './modules/App/CarbucksProtect/CarbucksProtect.vue' )
    },
    {
        path: '/smart-vehicle-health-monitor-order',
        name: 'Order Health Monitor',
        meta: {
            allowAnonymous: true,
            title: 'Order Health Monitor'
        },
        component: () => import( './modules/App/OrderHealthMonitor/OrderHealthMonitor.vue' )
    },
    {
        path: '/carbucks-privacy-policy',
        name: 'Privacy Policy',
        meta: {
            allowAnonymous: true,
            title: 'Privacy Policy'
        },
        component: () => import( './modules/App/PrivacyPolicy/PrivacyPolicy.vue' )
    },
    {
        path: '/carbucks-terms-of-service',
        name: 'Terms of Service',
        meta: {
            allowAnonymous: true,
            title: 'Terms of Service'
        },
        component: () => import( './modules/App/TermsOfService/TermsOfService.vue' )
    },
    {
        path: '/carbucks-app-end-user-license-agreement',
        name: 'EULA',
        meta: {
            allowAnonymous: true,
            title: 'EULA'
        },
        component: () => import( './modules/App/EULA/EULA.vue' )
    },
    {
        path: '/tmd',
        name: 'TMD',
        meta: {
            allowAnonymous: true,
            title: 'Target Market Determination'
        },
        component: () => import( './modules/App/TMD/TMD.vue' )
    },
    {
        path: '/sales',
        name: 'Presidian Sales Presentation',
        meta: {
            allowAnonymous: true,
            title: 'Sales Presentation',
            section: 'presentations'
        },
        component: () => import( './modules/Presentation/Presentations/Sales/Sales.vue' )
    },
    {
        path: '/carnex',
        name: 'Carnex Sales Presentation',
        meta: {
            allowAnonymous: true,
            title: 'Sales Presentation',
            section: 'presentations'
        },
        component: () => import( './modules/Presentation/Presentations/SalesCarnex/Sales.vue' )
    },
    {
        path: '/sales-full',
        name: 'Sales Presentation (Full)',
        meta: {
            allowAnonymous: true,
            title: 'Sales Presentation (Full)',
            section: 'presentations'
        },
        component: () => import( './modules/Presentation/Presentations/SalesFull/SalesFull.vue' )
    },
    {
        path: '/onboarding',
        name: 'Onboarding Presentation', 
        meta: {
            allowAnonymous: true,
            title: 'Onboarding Presentation',
            section: 'presentations'
        },
        component: () => import( './modules/Presentation/Presentations/Onboarding/Onboarding.vue' )
    },
    {
        path: '/presidian',
        name: 'Presidian Kickoff Presentation', 
        meta: {
            allowAnonymous: true,
            title: 'Presidian Kickoff Presentation',
            section: 'presentations'
        },
        component: () => import( './modules/Presentation/Presentations/PresidianKickoff/PresidianKickoff.vue' )
    },
    {
        path: '/reseller',
        name: 'Reseller Presentation', 
        meta: {
            allowAnonymous: true,
            title: 'Reseller Presentation',
            section: 'presentations'
        },
        component: () => import( './modules/Presentation/Presentations/Reseller/Reseller.vue' )
    },
    {
        path: '/global',
        name: 'Global Reseller Presentation', 
        meta: {
            allowAnonymous: true,
            title: 'Global Reseller Presentation',
            section: 'presentations'
        },
        component: () => import( './modules/Presentation/Presentations/Global/Global.vue' )
    },
    {
        path: '/sample',
        name: 'Sample Presentation', 
        meta: {
            allowAnonymous: true,
            title: 'Sample Presentation',
            section: 'presentations'
        },
        component: () => import( './modules/Presentation/Presentations/Sample/Sample.vue' )
    },
    {
        path: '/products/protect',
        name: 'PROTECT Explanation', 
        meta: {
            allowAnonymous: true,
            title: 'PROTECT Explanation',
            section: 'presentations'
        },
        component: () => import( './modules/App/Explanations/Protect/Protect.vue' )
    }
];


// Add the icons vue if we are in dev mode

export const navigation = new NavigationConfig();
